import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router";

import { URL_SEARCH_KEY } from "constants/urlQueryKeys";

const PATH_PARAM = "path";

/**
 *
 * @returns folder path without the file name
 */
const useFilesNavigation = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const folderPathSegments = useMemo(() => {
    const pathParam = searchParams.get(PATH_PARAM);
    return pathParam ? pathParam.split("/") : [];
  }, [searchParams]);

  const folderPath = useMemo(() => {
    return folderPathSegments.join("/");
  }, [folderPathSegments]);

  const setCurrentPath = useCallback(
    (path: string[]) => {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        next.delete(URL_SEARCH_KEY);
        if (path.length === 0) {
          next.delete(PATH_PARAM);
        } else {
          next.set(PATH_PARAM, path.join("/"));
        }
        return next;
      });
    },
    [setSearchParams]
  );

  const goUp = useCallback(() => {
    setCurrentPath(folderPathSegments.slice(0, -1));
  }, [setCurrentPath, folderPathSegments]);

  return { folderPathSegments, folderPath, setCurrentPath, goUp };
};

export default useFilesNavigation;
